import { useEffect, useState } from "react";

/**
 * The minimum time a screen keeps its loading tile up, independent of the
 * fetch. The tile is a content moment — a quote or a memory is worth a beat
 * even when the data was already warm — which is why every screen that shows
 * one has historically held its own floor.
 *
 * It used to be a copy-pasted setTimeout in five screens, two of them holding
 * the page for a flat ten seconds. This is that, once.
 *
 * The floor is forfeited the moment the content turns out to be suppressed
 * (see utils/loadingPreferences.js): with nothing to read there is nothing to
 * hold for, and the page should appear as soon as its data does.
 *
 * @param {number} ms - the floor for this screen.
 * @param {object} content - the tile content from useLoadingContent().
 * @returns {boolean} whether the screen should still consider itself loading.
 */
export const useLoadingFloor = (ms, content) => {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setElapsed(true), ms);
    return () => clearTimeout(id);
  }, [ms]);

  return !elapsed && !content?.suppressed;
};

export default useLoadingFloor;
